import React, { useState } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';

const FabricTransferModal = ({ thanDatashow, handleClose, thanFabrics, dateInDMY,onAddSelected }) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const handleCheckboxChange = (fabric) => {
    setSelectedRows((prevSelected) => {
      const exists = prevSelected.some((item) => item.id === fabric.id);
      if (exists) {
        return prevSelected.filter((item) => item.id !== fabric.id);
      } else {
        return [...prevSelected, fabric];
      }
    });
  };

  const handleAddClick = () => {
    console.log('Selected Fabrics:', selectedRows);
    // Do something with selectedRows
    if (onAddSelected) {
        onAddSelected(selectedRows); // 🔁 send data to parent
    }
  };

  return (
    <Modal show={thanDatashow} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Transfer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th></th>
              <th>#</th>
              <th>Name</th>
              <th>Warehouse</th>
              <th>Thaan No.</th>
              <th>QTY</th>
              <th>Price</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {thanFabrics?.map((fb, index) => (
              <tr key={fb.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.some((item) => item.id === fb.id)}
                    onChange={() => handleCheckboxChange(fb)}
                  />
                </td>
                <td>{index + 1}</td>
                <td className="text-start">{fb.name}</td>
                <td>{fb.warehouse_name}</td>
                <td>{fb.than_no}</td>
                <td>{fb.qty}</td>
                <td>{fb.price}</td>
                <td>{dateInDMY(fb.created_at)}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={8}>
                <Button type="button" className="btn btn-success" onClick={handleAddClick}>
                  + Add
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default FabricTransferModal;
